// Typed API client (T08 §9.8, T11): `paths` is generated from packages/schema/openapi/openapi.json by
// `pnpm --filter @vbltc/web openapi:types` (do not edit src/api/schema.d.ts). Auth is the Better Auth
// session cookie (same origin, credentials: include); no bearer token is ever stored in the browser.
import createFetchClient, { type Middleware } from "openapi-fetch";
import createClient from "openapi-react-query";
import { resilientFetch } from "./resilient-fetch";
import type { paths } from "./schema";

const requestId: Middleware = {
  onRequest({ request }) {
    // Correlation: the server echoes x-request-id and adds x-trace-id (T7).
    if (!request.headers.has("x-request-id"))
      request.headers.set("x-request-id", crypto.randomUUID());
    return request;
  },
};

// J-210: a 429 is waited out and sent again with "busy" shown, and a 401 ends the page's session.
export const fetchClient = createFetchClient<paths>({
  baseUrl: "/",
  credentials: "include",
  fetch: (request) => resilientFetch(request),
});
fetchClient.use(requestId);

/** TanStack Query hooks typed from the contract: $api.useQuery("get", "/api/users", { params: { query: { limit: 20 } } }) */
export const $api = createClient(fetchClient);
